import React, { useState } from 'react';
import { mockData } from './data';
import { MetricCard } from './MetricCard';
import { FilesDrilldown } from './FilesDrilldown';
import { TargetIcon, MousePointerClickIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function PerformanceGrid() {
  const [activeMetric, setActiveMetric] = useState<string | null>(null);
  return <>
      <motion.section initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.4,
      delay: 0.2
    }} className="bg-white rounded-xl shadow-sm border border-gray-200" data-id="element-326">
        <div className="bg-[#0A1F5C] text-white px-4 py-2.5 flex items-center justify-between gap-2 rounded-t-xl" data-id="element-327">
          <div className="flex items-center gap-2 font-semibold text-sm tracking-wide" data-id="element-328">
            <TargetIcon className="w-4 h-4" data-id="element-329" />
            PERFORMANCE (MONTH TO DATE)
          </div>
          <div className="hidden md:flex items-center gap-1.5 text-[10px] font-bold text-blue-200 uppercase tracking-wider" data-id="element-330">
            <MousePointerClickIcon className="w-3 h-3" data-id="element-331" />
            Click a card to drill into files
          </div>
        </div>

        <div className="p-5" data-id="element-332">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4" data-id="element-333">
            {mockData.performance.map(metric => <MetricCard key={metric.id} data={metric} onClick={() => setActiveMetric(metric.id)} data-id="element-334" />)}
          </div>
        </div>
      </motion.section>

      <FilesDrilldown metricId={activeMetric} onClose={() => setActiveMetric(null)} data-id="element-335" />
    </>;
}